import { Box, LinearProgress, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export default function PasswordStrengthIndicator({ password }) {
  const requirements = [
    { label: 'At least 8 characters', test: (pwd) => pwd.length >= 8 },
    { label: 'One uppercase letter', test: (pwd) => /[A-Z]/.test(pwd) },
    { label: 'One lowercase letter', test: (pwd) => /[a-z]/.test(pwd) },
    { label: 'One number', test: (pwd) => /\d/.test(pwd) },
    { label: 'One special character', test: (pwd) => /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/;'`~]/.test(pwd) },
  ];

  const metRequirements = requirements.filter((req) => req.test(password));
  const strength = (metRequirements.length / requirements.length) * 100;

  const getStrengthColor = () => {
    if (strength < 40) return 'error';
    if (strength < 80) return 'warning';
    return 'success';
  };

  const getStrengthLabel = () => {
    if (strength < 40) return 'Weak';
    if (strength < 80) return 'Medium';
    return 'Strong';
  };

  if (!password) return null;

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography variant="caption" sx={{ mr: 1 }}>
          Password Strength:
        </Typography>
        <Typography variant="caption" fontWeight="bold" color={`${getStrengthColor()}.main`}>
          {getStrengthLabel()}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={strength}
        color={getStrengthColor()}
        sx={{ height: 6, borderRadius: 3, mb: 1 }}
      />
      <Box sx={{ mt: 1 }}>
        {requirements.map((req, index) => {
          const isMet = req.test(password);
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.75rem',
                color: isMet ? 'success.main' : 'text.secondary',
                mb: 0.5,
              }}
            >
              {isMet ? (
                <CheckCircleIcon sx={{ fontSize: 16, mr: 0.5 }} />
              ) : (
                <CancelIcon sx={{ fontSize: 16, mr: 0.5 }} />
              )}
              <Typography variant="caption">{req.label}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
